import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Layout from './components/layout/Layout';
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Homepage from './components/pages/homepage/HomePage';
import Login from './components/pages/login/Login';
import BlogListing from './components/pages/blog/BlogListingPage'
import CreateBlogPage from './components/pages/blog/CreateBlogPage'
import BlogDetailsPage from './components/pages/blog/BlogDetailsPage'
import EditBlogPage from './components/pages/blog/EditBlogPage';

function App() {


  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Homepage />} />

          <Route path="/blogs" element={<BlogListing />} />
          <Route path="/create-blog" element={<CreateBlogPage />} />
          <Route path="/blogs/edit/:id" element={<EditBlogPage />} />
          <Route path="/blogs/:id" element={<BlogDetailsPage />} />



        </Route>
        <Route path='/login' element={<Login />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;